<template>
  <div class="video-container relative h-full"
        v-on:receivedEmoji="receiveReactions()">
        <div v-if="url" class="h-full">
            <div v-if="this.videoId && type != 'realtime'" class="overlay-container" @click="togglePlay()">
            </div>
            <div class="controls-container" v-if="!this.nocontrols">
                <div :class="`play-control ${!playing ? 'paused' : ''} `" @click="togglePlay()" v-if="type != 'realtime'">
                    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-if="!playing" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M31.356 25.677l38.625 22.3c1.557.899 1.557 3.147 0 4.046l-38.625 22.3c-1.557.899-3.504-.225-3.504-2.023V27.7c0-1.798 1.946-2.922 3.504-2.023z"/><path d="M69.981 47.977l-38.625-22.3a2.343 2.343 0 00-.716-.259l37.341 21.559c1.557.899 1.557 3.147 0 4.046l-38.625 22.3a2.296 2.296 0 01-1.078.301c.656.938 1.961 1.343 3.078.699l38.625-22.3c1.557-.899 1.557-3.147 0-4.046z"/><path d="M31.356 25.677l38.625 22.3c1.557.899 1.557 3.147 0 4.046l-38.625 22.3c-1.557.899-3.504-.225-3.504-2.023V27.7c0-1.798 1.946-2.922 3.504-2.023z" fill="none" stroke="#fff" stroke-miterlimit="10"/></svg>
                    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-if="playing" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M39.806 72.858h-8.915a3.94 3.94 0 01-3.94-3.94V31.119a3.94 3.94 0 013.94-3.94h8.915a3.94 3.94 0 013.94 3.94v37.799a3.94 3.94 0 01-3.94 3.94zM68.109 72.821h-8.915a3.94 3.94 0 01-3.94-3.94V31.082a3.94 3.94 0 013.94-3.94h8.915a3.94 3.94 0 013.94 3.94v37.799a3.94 3.94 0 01-3.94 3.94z"/><path d="M40.489 27.248a3.919 3.919 0 011.257 2.871v37.799a3.94 3.94 0 01-3.94 3.94h-8.915c-.234 0-.46-.03-.683-.069a3.916 3.916 0 002.683 1.069h8.915a3.94 3.94 0 003.94-3.94V31.119a3.934 3.934 0 00-3.257-3.871zM68.792 27.211a3.919 3.919 0 011.257 2.871v37.799a3.94 3.94 0 01-3.94 3.94h-8.915c-.234 0-.46-.03-.683-.069a3.916 3.916 0 002.683 1.069h8.915a3.94 3.94 0 003.94-3.94V31.082a3.933 3.933 0 00-3.257-3.871z"/><path d="M39.806 72.858h-8.915a3.94 3.94 0 01-3.94-3.94V31.119a3.94 3.94 0 013.94-3.94h8.915a3.94 3.94 0 013.94 3.94v37.799a3.94 3.94 0 01-3.94 3.94zM68.109 72.821h-8.915a3.94 3.94 0 01-3.94-3.94V31.082a3.94 3.94 0 013.94-3.94h8.915a3.94 3.94 0 013.94 3.94v37.799a3.94 3.94 0 01-3.94 3.94z" fill="none" stroke="#000" stroke-miterlimit="10"/></svg>
                </div>
                
                <div class="time-control" v-if="type != 'realtime' && progress">
                     <vue-slider v-model="videoTime"
                        ref="slider"
                        @change="refreshTime()"
                        :min="0"
                        :tooltip="'hover'"
                        :max="videoDuration"
                        :tooltipFormatter="formatTime"
                        @mousemove.native="mousemoveHandle"
                        :interval="1">
                            <div
                            :style="{ left: `${left}%` }"
                            :class="[
                                'custom-tooltip',
                                'vue-slider-dot-tooltip-inner',
                                'vue-slider-dot-tooltip-inner-top',
                            ]"
                            >
                            {{ formatTime(tooltipValue) }}
                            </div>
                        </vue-slider>
                </div>
                <div class="sound-control flex flex-row items-center justify-center">
                    <div class="volume-control mr-4">
                        <vue-slider v-model="audioLevel"
                            @change="refreshVolume()"
                            :width="100"
                            :min="0"
                            :max="100"
                            :interval="1"></vue-slider>
                    </div>
                    <div class="mute-control">
                        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" @click="toggleMute()" v-if="muted" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10 16V0L3 5H0v6h3zM14.646 5.646L13 7.293l-1.646-1.647-.708.708L12.293 8l-1.647 1.646.708.708L13 8.707l1.646 1.647.708-.708L13.707 8l1.647-1.646z"/></svg>
                        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" @click="toggleMute()" v-else="" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10 16V0L3 5H0v6h3zM11 13.91c2.837-.477 5-2.938 5-5.91s-2.163-5.433-5-5.91v1.011c2.279.465 4 2.484 4 4.899s-1.721 4.434-4 4.899v1.011z"/><path d="M11 9.722v1.094c1.163-.413 2-1.512 2-2.816s-.837-2.403-2-2.816v1.094c.595.347 1 .985 1 1.722s-.405 1.375-1 1.722z"/></svg>
                    </div>
                </div>
                <div class="fullscreen" v-if="fullscreenable" @click="toggleFullscreen()">
                    <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-if="!fullscreen" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M30 0H6a5.997 5.997 0 00-6 6v24a6 6 0 0012 0V12h18a6 6 0 000-12zM90 0H66a6 6 0 000 12h18v18a6 6 0 0012 0V6a5.997 5.997 0 00-6-6zM30 84H12V66a6 6 0 00-12 0v24a5.997 5.997 0 006 6h24a6 6 0 000-12zM90 60a5.997 5.997 0 00-6 6v18H66a6 6 0 000 12h24a5.997 5.997 0 006-6V66a5.997 5.997 0 00-6-6z"/></svg>
                    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-if="fullscreen" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 11h3v3h2V9H0v2zm3-8H0v2h5V0H3v3zm6 11h2v-3h3V9H9v5zm2-11V0H9v5h5V3h-3z" fill="#000" fill-rule="evenodd"/></svg>
                </div>
            </div>
            <div class="h-full" v-if="isLiveVideo">
                <VideoJS @on-ready="updateVjsPlayer" :options="videoJsOptions"></VideoJS>
            </div>
            <div v-else class="vue-player-container h-full"></div>
        </div>
  </div>
</template>

<script>
    import VideoJS from './VideoJS'
    import Vue from 'vue';
    import VueSlider from 'vue-slider-component'
    import videojs from "video.js";
    import videojsYoutube from "videojs-youtube";

    export default {
        name: 'Video',
        props: {
            url: String,
            baseUrl: String,
            type: String,
            play_mode: String,
            emojis: {
                type: Object,
                default: null
            },
            autoplay: {
                type: Boolean,
                default: false
            },
            automuted: {
                type: Boolean,
                default: false
            },
            nocontrols: {
                type: Boolean,
                default: false
            },
            localizable: {
                type: Boolean,
                default: false
            },
            loop: {
                type: Boolean,
                default: false
            },
            fullscreenable: {
                type: Boolean,
                default: false
            },
            progress: {
                type: Boolean,
                default: true
            },
            quality: {
                type: Number,
                default: 1080
            },
            is_vod_realtime: {
                type: Boolean,
                default: false
            },
            startChannel: {
                type: Number,
                default: null
            },
        },
        components: {
            VideoJS,
            VueSlider
        },
        data: function() {
            return {
                width: 1200,
                height: 1200 * 9 / 16,
                vPlayer: null,
                livePlayer: null,
                muted: false,
                audioLevel: 100,
                fullscreen: false,
                playing: false,
                videoTime: 0,
                videoDuration: 0,
                left: 0,
                tooltipValue: 0,
                diffusionEnded: false,
                emojiList: [
                    'happy',
                    'clap',
                    'kiss',
                    'unicorn',
                    'heart',
                    'logo',
                ],
                showClickSound: true,
                reactionList: [],
                ownEmoji: {},
                lastAnimation: 0
            }
        },
        computed: {
            isLiveVideo() {
                return !this.videoId;
            },
            videoJsOptions() {
                const isYoutube = this.url.match(/youtu/);
                const options = {
                    autoplay: this.autoplay,
                    controls: false,
                    sources: [{
						src: this.url,
                        type: isYoutube ? 'video/youtube' : "application/x-mpegURL"
					}]
                }
                if (isYoutube) {
                    options.techOrder =  ["youtube"];
                    options.youtube =   { "ytControls": 2 };
                }
                return options;
            },
            videoId: function() {
                if (!this.url) {
                    return false;
                }
                var regExp = /https:\/\/(www\.)?vimeo.com\/([\w\/]+)($|\/)/;

                var match = this.url.match(regExp);

                if (match) {
                    return match[2];
                }
                return false;
            }
        },
        mounted: function() {
            this.updateWidth();
            if (this.automuted) {
                this.muted = true;
                this.audioLevel = 0;
            }
            this.loadVideo();
            this.moveReactions();
        },
        deactivated: function() {
            this.vjsPlayer = null;
            this.vPlayer = null;
        },
        watch: {
            url: function(newValue) {
                Vue.nextTick(() => {
                    this.loadVideo();
                });
                this.$store.commit('setRatings', false);
                this.$store.commit('changeRating', {type: 'Content', value: null})
                this.$store.commit('changeRating', {type: 'Speaker', value: null})
                this.videoTime = 0;
                this.videoDuration = 0;
                if (!newValue) {
                    this.vPlayer = null;
                    this.vjsPlayer = null;
                }
            },
            goToTime(newValue, oldValue) {
                if (newValue !== null && this.$store) {
                    // Empty the store when it's done
                    this.$store.commit('videoTime', newValue);
                    this.$store.commit('goToTime', null);
                    if (this.vPlayer) {
                        this.vPlayer.setCurrentTime(newValue);
                    }
                    if (this.vjsPlayer) {
                        this.vjsPlayer.currentTime(newValue);
                    }
                    this.playVideo();
                }
            },
            emojis: function (newValue) {
                this.receiveReactions(newValue);
            }
        },
        methods: {
            
            formatLocale(locale) {
                const localesArray = locale.split('-');
                return localesArray[localesArray.length - 1];
            },
            changeLocale(newLocale) {
            },
            pushReaction(type) {
                // Send to api
                window.liveSession.pushEmoji(type);
                this.addReaction(type);
                if (!this.ownEmoji[type]) {
                    this.ownEmoji[type] = 0;
                }
                this.ownEmoji[type]++;
            },
            receiveReactions(emojis) {
                for (let emojiType in emojis) {
                    for (let i = 0; i < emojis[emojiType]; i++) {
                        if (this.ownEmoji[emojiType]) {
                            this.ownEmoji[emojiType]--;
                            continue;
                        }
                        this.addReaction(emojiType);
                    }
                }
            },
            addReaction(type) {
                const leftRand = Math.floor(Math.random() * 90);
                const scaleRand = Math.random() * (1.2 - 0.8) + 0.8;
                const velocityRand = Math.random() * (1.5 - 0.5) + 0.5;

                const newReaction = {
                    type,
                    scale: scaleRand,
                    left: leftRand,
                    top: 100,
                    opacity: 0,
                    velocity: velocityRand,
                    id: this.getUniqueID(),
                    moveDirection: (1 - Math.random() * 2)
                };
                this.reactionList.push(newReaction);
            },
            moveReactions(elapsed) {
                window.requestAnimationFrame((time) => {
                    const elapsed = time - this.lastAnimation;
                    this.lastAnimation = time;
                    this.moveReactions(elapsed);
                });
                if (!elapsed) {
                    return;
                }
                if (!this.reactionList.length) {
                    return;
                }
                const frameSpeed = elapsed / 50;
                this.reactionList.forEach((item, index, data) => {
                    const velocity = item.velocity;
                    const move = frameSpeed * 2.5 * item.velocity;
                    item.top -= move;


                    // Fade in / fade out
                    if (item.top < 20) {
                        item.opacity = item.top / 20;
                    } else if (item.top > 90) {
                        item.opacity = (100 - item.top) / 10;
                    } else {
                        item.opacity = 1;
                    }

                    // Shake the emoji left/right
                    let moveRand = frameSpeed * velocity * (Math.random()) * item.moveDirection;
                    item.left += moveRand * velocity;
                    if (item.left > 100) {
                        item.left = 100;
                    } else if (item.left < 0) {
                        item.left = 0;
                    }

                    if (item.top < 0) {
                        this.reactionList.splice(index, 1);
                        return;
                    }

                    this.reactionList[index] = item;
                })
            },
            formatTime(time) {
                var sec_num = parseInt(time, 10); // don't forget the second param
                var hours   = Math.floor(sec_num / 3600);
                var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                var seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours && hours   < 10) {hours   = "0"+hours;}
                if (minutes < 10) {minutes = "0"+minutes;}
                if (seconds < 10) {seconds = "0"+seconds;}
                return (hours ? (hours+':') : '')+minutes+':'+seconds;
            },
            toggleMute() {
                this.muted = !this.muted;
                this.refreshVolume();
            },
            togglePlay() {
                this.playing = !this.playing;
                if (this.vjsPlayer) {
                    if (!this.playing) {
                        this.vjsPlayer.pause();
                    } else {
                        this.vjsPlayer.play();
                    }
                } else {
                    if (!this.playing) {
                        this.vPlayer.pause();
                    } else {
                        this.vPlayer.play();
                    }
                }
            },
            pauseVideo() {
                this.playing = false;
                if (this.vPlayer) {
                    this.vPlayer.pause();
                }
            },
            getUniqueID() {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
                }
                return s4() + s4() + s4() + '-' + s4() + s4();
            },
            refreshTime() {
                if (this.type != 'realtime') {
                    if (this.vPlayer) {
                        this.vPlayer.setCurrentTime(this.videoTime);
                    } else if (this.vjsPlayer) {
                        this.vjsPlayer.currentTime(this.videoTime);
                    }
                }
            },
            mousemoveHandle(e) {
                const sliderVm = this.$refs.slider
                sliderVm.setScale()
                this.left = sliderVm.getPosByEvent(e)
                this.tooltipValue = sliderVm.control.getValueByPos(this.left)
            },
            refreshVolume() {
                if (this.vPlayer) {
                    this.vPlayer.setVolume(this.muted ? 0 : this.audioLevel / 100);
                } else {
                    this.vjsPlayer.muted(this.muted);
                    this.vjsPlayer.volume(this.muted ? 0 : this.audioLevel / 100)
                }
            },
            updateVjsPlayer(player) {
                this.vjsPlayer = player;
                this.vjsPlayer.on('loadedmetadata', () => {
                    this.videoDuration = Math.ceil(this.vjsPlayer.duration());
                });
                if (this.autoplay) {
                    this.playVideo();
                }
                this.checkVideoTime();
            },
            updateWidth: function() {
                this.width = this.$el.clientWidth;
                this.height = this.width * 9 / 16;
                const el = this.$el.querySelector('.vue-player-container iframe');
                if (el) {
                    el.width = this.width;
                    el.height = this.height;
                }
            },
            loadVideo: function() {
                const container = this.$el.querySelector('.vue-player-container');
                if (this.videoId) {
                    if (this.vPlayer && parseInt(this.videoId) == this.videoId) {
                        this.vPlayer.loadVideo(this.videoId).then(() => {
                            if (this.autoplay) {
                                this.playVideo();
                            }
                        }).catch((e) => {
                            console.log(e);
                        });
                    } else {
                        let params = {
                            width: this.width,
                            height: this.height,
                            loop: this.loop,
                            controls: false,
                            keyboard: false,
                            pip: false,
                            muted: this.automuted,
                            quality: this.quality,
                            autopause: false,
                        };
                        if (parseInt(this.videoId).toString() == this.videoId) {
                            params.id = this.videoId;
                        } else {
                            params.url = this.url;
                        }

                        if (this.vPlayer) {
                            this.vPlayer.destroy();
                        }

                        this.vPlayer = new Vimeo.Player(container, params);
                        this.updateWidth();

                        this.vPlayer.on('play', (data) => {
                            this.updateVideoDuration();
                            if (this.automuted) {
                                this.refreshVolume()
                            }
                            this.updateWidth();
                        });
                        this.vPlayer.on('timeupdate', (data) => {
                            if (this.automuted) {
                                this.refreshVolume()
                            }
                            if (parseInt(data.seconds) && parseInt(data.seconds) < this.videoDuration) {
                                this.videoTime = data.seconds;
                            }
                            if (this.videoDuration && this.videoTime >= this.videoDuration - 30) {
                            }
                        });

                        this.vPlayer.on('ended', () => {
                        })
                    }
                } else {
                    this.vPlayer = null;
                }
                if (this.autoplay) {
                    this.playVideo();
                }
            },
            toggleFullscreen : function() {
                var fullscreenChange = null;
                    // other vars …

                // Check for fullscreen support
                if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {

                    // If there's currently an element fullscreen, exit fullscreen
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                    this.fullscreen = false;
                } else {
                    const videoWrapper = this.$el;
                    // Otherwise, enter fullscreen
                    // `videoWrapper` is just a `div` element wrapping the video
                    if (videoWrapper.requestFullscreen) {
                        videoWrapper.requestFullscreen();
                    } else if (videoWrapper.mozRequestFullScreen) {
                        videoWrapper.mozRequestFullScreen();
                    } else if (videoWrapper.webkitRequestFullscreen) {
                        videoWrapper.webkitRequestFullscreen();
                    } else if (videoWrapper.msRequestFullscreen) {
                        videoWrapper.msRequestFullscreen();
                    }

                    this.fullscreen = true;
                }

                fullscreenChange = () => {
                    console.log('fs change');
                    //this.updateWidth();
                };

                document.onfullscreenchange = function() {
                    if (!document.fullscreenElement) {
                        fullscreenChange();
                    }
                };
                document.onwebkitfullscreenchange = function() {
                    if (!document.webkitFullscreenElement) {
                        fullscreenChange();
                    }
                };
                document.onmozfullscreenchange = function() {
                    if (!document.mozFullScreenElement) {
                        fullscreenChange();
                    }
                };
                document.onmsfullscreenchange = function() {
                    if (!document.msFullscreenElement) {
                        fullscreenChange();
                    }
                };
            },
            playSound: function() {
                this.showClickSound = false;
                this.muted = false;
                this.audioLevel = 100;
                this.refreshVolume();
                this.playVideo();
            },
             playVideo: function() {
                if (this.vPlayer) {
                    this.vPlayer.play().then(() => {
                        this.updateVideoDuration();
                    }).catch(error => {
                        this.vPlayer.setVolume(0).then(() => {
                            this.muted = true;
                            this.playVideo();
                        });
                    });
                    this.playing = true;
                    this.vPlayer.getVolume((volume) => {
                        if (!volume) {
                            this.vPlayer.setVolume(this.audioLevel * 100);
                        }
                    })
                } else if (this.vjsPlayer) {
                    this.playing = true;
                    this.vjsPlayer.play();
                    this.updateVideoDuration();
                }
                /*axios.post('/stats/record-action', {
                    type: 2,
                    extra: {'video':'trailer'},
                });*/
                this.checkVideoTime();
            },
            updateVideoDuration()
            {
                if (this.vPlayer) {
                    this.vPlayer.getDuration().then((duration) => {
                        this.videoDuration = parseInt(duration);
                    })
                } else {
                   
                }
            },
            checkVideoTime: function() {
                if (this.type != 'realtime') {
                    if (this.vPlayer) {
                        this.vPlayer.getCurrentTime().then((seconds) => {
                        });
                    } else if (this.vjsPlayer) {
                        this.videoTime = this.vjsPlayer.currentTime();
                    }
                    
                    setTimeout(() => {
                        this.checkVideoTime()
                    }, 1000);
                    return;
                }
                let start = this.startChannel;
                if (start && this.is_vod_realtime) {
                    const time = Math.ceil(Date.now() / 1000);
                    const videoRealStartTime = start;
                    const position = time - videoRealStartTime;
                    if (this.vPlayer) {
                        this.vPlayer.getCurrentTime().then((seconds) => {
                            if (seconds <= position - 10 || seconds >= position + 10) {
                                this.vPlayer.setCurrentTime(position);
                            }
                        });
                    } else {
                        if (this.vjsPlayer) {
                            let seconds = this.vjsPlayer.currentTime();
                             if (seconds <= position - 10 || seconds >= position + 10) {
                                 this.vjsPlayer.currentTime(position);
                             }
                        }
                    }
                }

                setTimeout(() => {
                    this.checkVideoTime()
                }, 3000);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .poster {
        background: #000;
        z-index: 40;
        position: absolute;
        width: 100%;
        height: 100%;
        img {
            min-width: 100%;
            min-width: 100%;
            opacity: 0.7;
        }
    }

    .list-locales {
        position: absolute;
        bottom: 6px;
        left: 50px;
        transition: all .2s;
        z-index: 40;
        color: #fff;
        text-transform: uppercase;
        font-size: 16px;
        opacity: 0;

        .currentLocale {
            padding: 5px 10px;
        }

        &:hover {
            .list-locales-choices {
                display: block;
            }
        }

        .list-locales-choices {
            position: absolute;
            bottom: 100%;
            background: rgba(#000, .4);
            padding: 5px 10px;
            display:none;

            .item {
                cursor: pointer;

                &:hover {
                    font-weight: 700;
                }
            }
        }
    }

    #player-container:empty {
        padding-bottom: 56.25%;
    }

    .video-trigger {
        cursor: pointer;
        position: absolute;
        z-index: 43;
        background: rgba(#000, .8);
        color: #fff;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        font-weight: normal;
        font-size: 38px;
        line-height: 44px;
        padding: 20px;
        text-align: center;

        &.light {
            background: rgba(#000, .2);
        }

        .icon {
            z-index: 45;
            position: relative;
        }
        svg {
            width: 200px;
            opacity: .7;
            transition: all .2s;
            outline: none;

            [stroke] {
                stroke: #fff;
                stroke-width: .75;
            }
        }

        &:hover {
            svg {
                opacity: 1;
            }
        }
    }

    .iframe-video {
        width: 100%
    }



    .controls-container {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        background: rgba(#000, .4);
        opacity: 0;
        transition: all .2s;
        z-index: 20;
    }

    .overlay-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(#fff, .001);
        opacity: 0;
        transition: all .2s;
    }

    .video-container {
        overflow: hidden;

        &:hover {
            .controls-container, .overlay-container {
                opacity: 1;
            }

            .list-locales {
                opacity: 1;
            }
        }
    }

    .time-control {
        position: absolute;
        bottom: 33px;
        right: 0px;
        width:100%;


        .vue-slider {
            position: relative;

            .custom-tooltip {
                position: absolute;
                bottom: 100%;
                transform: translate(-50%, -15px);
                display: none;
            }

            &:hover .custom-tooltip {
                display: block;
            }
        }
    }

    .fullscreen {
        position: absolute;
        bottom: 8px;
        right: 12px;
        cursor: pointer;

        svg {
            width: 24px;
            outline: none;

            * {
                fill: #fff;
            }
        }
    }

    .sound-control {
        position: absolute;
        bottom: 8px;
        right: 100px;
        cursor: pointer;

        svg {
            width: 24px;
            outline: none;

            * {
                 fill: #fff;
            }
        }
    }

    .play-control {
        position: absolute;
        bottom: 2px;
        left: 12px;
        cursor: pointer;

        svg {
            width: 36px;
            outline: none;

            * {
                 fill: #fff;
            }
        }
    }

    .emoji-container {
        position: absolute;
        bottom: 60px;
        right: 20px;
        background: rgba(#fff, .2);
        display: flex;
        border-radius: 5px;
        z-index: 10;
        transition: all .2s;
        width: 42px;

        &:hover {
            background: #fff;
            width: 252px;

            .emoji:not(:first-child) {
                display: block;
            }
        }

        .emoji {
            width: 32px;
            height: 32px;
            transition: all .2s;
            border-radius: 100%;
            margin: 5px;
            cursor: pointer;
            position: relative;

            &:not(:first-child) {
                display: none;
            }

            &:after {
                content: "";
                background: url('/images/sprite-24.png');
                background-position: 0 0;
                position: absolute;
                top: 4px;
                right: 4px;
                width: 24px;
                height: 24px;
            }

            &.logo {
                &:after {
                    background-position: 0 0;
                }
            }

            &.happy {
                &:after {
                    background-position: calc(24px * 8) calc(24px * 27);
                }
            }

            &.clap {
                &:after {
                    background-position: calc(24px * 41) calc(24px * 16);
                }
            }

            &.kiss {
                &:after {
                    background-position: calc(24px * 8) calc(24px * 16);
                }
            }

            &.unicorn {
                &:after {
                    background-position: calc(24px * 3) calc(24px * 18);
                }
            }

            &.heart {
                &:after {
                    background-position: calc(24px * 12) calc(24px * 38);
                }
            }

            &:hover {
                box-shadow: 1px 1px 5px #00000070
            }
        }
    }

    .reaction-container {
        position: absolute;
        top: 20px;
        height: calc(100% - 132px);
        width: 125px;
        right: 20px;


        .emoji {
            position: absolute;
            width: 32px;
            height: 32px;
            background: #fff;
            background: url('/images/sprite-32.png');
            background-position: 0 0;

            &.logo {
                background-position: 0 0;
            }

            &.happy {
                background-position: calc(32px * 8) calc(32px * 27);
            }

            &.clap {
                background-position: calc(32px * 41) calc(32px * 16);
            }

            &.kiss {
                background-position: calc(32px * 8) calc(32px * 16);
            }

            &.unicorn {
                background-position: calc(32px * 3) calc(32px * 18);
            }

            &.heart {
                background-position: calc(32px * 12) calc(32px * 38);
            }
        }
    }

</style>

